'use strict'

const Vue = require('vue')
const CompositionApi = require('@vue/composition-api')

function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : { default: e }
}

const Vue__default = /*#__PURE__*/ _interopDefaultLegacy(Vue)
const CompositionApi__default = /*#__PURE__*/ _interopDefaultLegacy(
  CompositionApi
)

Vue__default['default'].use(CompositionApi__default['default'])
